export const format = price => `$${price}`

export const formatUsd = price => `${format(price)} USD`

export const formatUsdYearly = price => `${formatUsd(price)}/yr`
